import { createSelector } from '@reduxjs/toolkit';

const getVideosState = (state) => state.videos;

const getVideos = createSelector(getVideosState, (videos) => videos.data);

export default getVideos;
